<template>
  <div class="containerSearchDirection">
    <el-row :gutter="20" class="rowComponentOfDirection">
      <el-col :span="24">
        <DistritoTypeAhead
          ref="inputDistrito"
          @selectDistrito="distritoSelected"
          @cleanDistrictEmittion="cleanComponentsOfDirectionByDistrito"
        ></DistritoTypeAhead>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="rowComponentOfDirection">
      <el-col :span="24">
        <ViaTypeahead
          ref="inputVia"
          @eventSelectVia="selectVia"
          @cleanViaEmittion="cleanComponentsOfDirectionByVia"
        ></ViaTypeahead>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="rowComponentOfDirection rowNumberDirection">
      <el-col :span="24">
        <div class="inner-addon right-addon">
          <i
            class="uil uil-search glyphicon iconInput"
            v-show="isEmptyNumber"
          ></i>
          <i
            class="uil uil-times glyphicon iconInput"
            style="cursor: pointer"
            v-show="isDirtyNumber"
            @click="cleanInputNumber"
          ></i>
          <vs-input
            type="number"
            class="inputNumberDirection"
            placeholder="Numero de domicilio"
            ref="refInputNumberVia"
            v-model="numberDirection"
            @keydown.enter="pressEnterNumVia"
          />
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="rowComponentOfDirection">
      <el-col :span="24">
        <NucleoUrbano
          ref="inputNucleoUrbano"
          @eventSelectNucleoUrbano="nucleoUrbanoSelected"
          @cleanNucleoUrbanoEmittion="cleanComponentsOfDirectionByNucleoUrbano"
        ></NucleoUrbano>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="rowComponentOfDirection">
      <el-col :span="24">
        <div class="inner-addon right-addon">
          <i
            class="uil uil-search glyphicon iconInput"
            v-show="isEmptyManzana"
          ></i>
          <i
            class="uil uil-times glyphicon iconInput"
            style="cursor: pointer"
            v-show="isDirtyManzana"
            @click="cleanInputManzana"
          ></i>
          <vs-input
            ref="refInputManzana"
            class="inputManzana"
            placeholder="Manzana"
            v-model="manzanaDirection"
            @keydown.enter="pressEnterManzanaDirection"
          />
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="rowComponentOfDirection">
      <el-col :span="24">
        <div v-if="nivel_search" :class="classForPrecision">
          <label>{{ nivel_search }}</label>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="rowComponentOfDirection rowbtnSearchDirection">
      <el-col :span="24">
        <el-button
          class="btnSearchDirection"
          type="success"
          @click="searchDirection"
          >Buscar</el-button
        >
      </el-col>
    </el-row>

    <!-- componenete de busqueda -->
    <el-row :gutter="20">
      <el-col :span="24">
        <div style="padding-top: 20px; text-align: center">Distribucion:</div>
      </el-col>
    </el-row>

    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <img
          style="height: 60px; border-radius: 5px"
          src="@/assets/images/pardos_h.png"
          class="image"
        />
      </div>
      <div class="text item">
        <el-row :gutter="20">
          <el-col :span="10">Restaurant: </el-col>
          <el-col :span="14" class="value-delivery"
            >{{ delivery.restaurant }}
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="10">Distancia: </el-col>
          <el-col :span="14" class="value-delivery"
            >{{ delivery.distancia }} Km
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="10">Unidad: </el-col>
          <el-col :span="14" class="value-delivery"
            >{{ delivery.unidad }}
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="10">Proveedor: </el-col>
          <el-col :span="14" class="value-delivery"
            >{{ delivery.proveedor }}
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="10">Codigo: </el-col>
          <el-col :span="11" id="foo">
            <el-input
              class="delivery_code"
              ref="inputCode"
              v-model="delivery.codigo"
            ></el-input>
          </el-col>
          <el-col :span="3">
            <el-tooltip
              class="item"
              effect="dark"
              content="Copiar"
              placement="top"
            >
              <i
                @click="copyText"
                style="cursor: pointer"
                class="el-icon-document-copy"
              ></i>
            </el-tooltip>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24" class="notaDelivery"
            ><b>*Nota:</b> Copiar el codigo en observaciones
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
import DistritoTypeAhead from "./DistritoTypeAhead";
import ViaTypeahead from "./ViaTypeAhead";
import NucleoUrbano from "./NucleoUrbanoTypeAhead";

import axios from "axios";

import { mapState, mapMutations } from "vuex";

// const DEFAULT_TOKEN = 'c7fab301-31d8-4618-b452-bc82e361d9bf';

export default {
  components: {
    DistritoTypeAhead,
    ViaTypeahead,
    NucleoUrbano,
  },

  data() {
    return {
      numberDirection: "",
      isFocusNumber: false,
      manzanaDirection: "",
      access_token: "",
      device: "Desktop",
      urlBase: "",
      urlBaseDelivery: "",
      nivel_search: "",
      classForPrecision: "",
      geocoderApi: null,
      resultados: [],

      srcImgCompany: "@/assets/images/pardos.jpg",

      delivery: {
        restaurant: "",
        proveedor: "",
        unidad: "",
        distancia: "0",
        codigo: "",
      },
    };
  },

  created() {
    this.urlBase = process.env.VUE_APP_GEOCODING;
    this.access_token = process.env.VUE_APP_TOKEN_APIS;
    this.urlBaseDelivery = process.env.VUE_APP_BUILDER_HOST;
  },
  mounted() {
    let app = this;
    if (app.checkLogin()) {
      const tokenData = JSON.parse(window.localStorage.getItem("geodir_Token"));
      app.access_token = tokenData.data.access_token;
    }

    //Seleccionar el primer elemento
    console.log("SE MONTO EL COMPONENET DIRECCION");
    this.$refs["inputDistrito"].$el.focus();
    this.$refs["refInputNumberVia"].$el.querySelector("input").value = "";
  },
  computed: {
    ...mapState(["map"]),
    isEmptyNumber() {
      return this.numberDirection === "";
    },

    isDirtyNumber() {
      return !!this.numberDirection;
    },

    isEmptyManzana() {
      return this.manzanaDirection === "";
    },

    isDirtyManzana() {
      return !!this.manzanaDirection;
    },
  },

  methods: {
    copyText() {
      var vm = this;
      /* Get the text field */
      var copyText = vm.$refs.inputCode;
      /* Select the text field */
      copyText.select();
      /* Copy the text inside the text field */
      document.execCommand("copy");
      /* Alert the copied text */
      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "successful" : "unsuccessful";
        console.log("Fallback: Copying text command was " + msg);
      } catch (err) {
        console.error("Fallback: Oops, unable to copy", err);
      }
    },
    cleanInputNumber() {
      this.numberDirection = "";
      this.$refs["refInputNumberVia"].$el.querySelector("input").focus();
    },

    cleanInputManzana() {
      this.manzanaDirection = "";
      this.$refs["refInputManzana"].$el.querySelector("input").focus();
    },

    distritoSelected(e) {
      console.log("sE SELECCCIONO EL DISTRITO");
      this.$refs["inputVia"].$el.querySelector("input").focus();
      //this.$el.querySelector('input').focus()
    },

    nucleoUrbanoSelected() {
      this.$refs["refInputManzana"].$el.querySelector("input").focus();
    },

    cleanComponentsOfDirectionByDistrito() {
      this.$store.commit("store_setUbigeo", "");

      this.$refs["inputVia"].data = "";
      this.$store.commit("SET_TIPO_VIA_DIRECTION", 0);
      this.$store.commit("SET_VIA_DIRECTION", "");

      this.$refs["inputNucleoUrbano"].data = "";
      this.$store.commit("SET_TIPO_NU_DIRECTION", 0);
      this.$store.commit("SET_NU_DIRECTION", "");

      this.numberDirection = "";
      this.manzanaDirection = "";

      this.nivel_search = "";
    },

    cleanComponentsOfDirectionByVia() {
      this.$store.commit("SET_TIPO_VIA_DIRECTION", 0);
      this.$store.commit("SET_VIA_DIRECTION", "");

      this.$refs["inputNucleoUrbano"].data = "";
      this.$store.commit("SET_TIPO_NU_DIRECTION", 0);
      this.$store.commit("SET_NU_DIRECTION", "");

      this.numberDirection = "";
      this.manzanaDirection = "";

      this.nivel_search = "";
    },

    cleanComponentsOfDirectionByNucleoUrbano() {
      this.manzanaDirection = "";
    },

    checkLogin() {
      return this.$store.state.isLoggedIn;
    },

    selectVia() {
      this.isFocusNumber = true;
      this.$refs["refInputNumberVia"].$el.querySelector("input").focus();
      this.$refs["refInputNumberVia"].$el.querySelector("input").value = "";
      //document.getElementById("numberDirection").focus();
    },

    /*cleanInputNumber(){
      this.numberDirection = '';
      document.getElementById("numberDirection").focus();
    },*/

    pressEnterNumVia(e) {
      let codePressEnter = 13;
      if (e.keyCode === codePressEnter) {
        this.searchDirection();
      }
    },

    pressEnterManzanaDirection(e) {
      let codePressEnter = 13;
      if (e.keyCode === codePressEnter) {
        this.searchDirection();
      }
    },

    searchDirection() {
      //primero asiganr el token
      let layerMarker = this.$store.getters.layerMarkerSearcher;
      if (layerMarker) {
        //this.$store.commit("SET_LAYER_MARKER", marker)
        this.map.removeLayer(layerMarker);
      }

      let ubigeoOfStore = this.$store.getters.ubigeo;
      let viaOfStore = this.$store.getters.via;
      let tipoViaOfStore = this.$store.getters.tipoVia;
      let nameNucleoUrbano = this.$store.getters.nucleoUrbano;
      let tipoNucleoUrbano = this.$store.getters.tipoNucleoUrbano;

      let address;
      let addressArray = [];

      let nameRoute = "";
      if (viaOfStore) {
        if (tipoViaOfStore) {
          nameRoute = tipoViaOfStore + " " + viaOfStore;
        } else {
          nameRoute = viaOfStore;
        }
      }

      addressArray.push(nameRoute);
      if (this.numberDirection) {
        addressArray.push("nro " +this.numberDirection);
      }

      let nameSublocality = "";
      if (nameNucleoUrbano) {
        if (tipoNucleoUrbano) {
          nameSublocality = tipoNucleoUrbano + " " + nameNucleoUrbano;
        } else {
          nameSublocality = "urb " + nameNucleoUrbano;
        }
      }

      addressArray.push(nameSublocality);

      if (this.manzanaDirection) {
        addressArray.push("mzn " + this.manzanaDirection);
      }

      address = addressArray.join(" ").trim();

      let url =
        this.urlBase +
        "address=" +
        address +
        "&segments=locality_id:" +
        ubigeoOfStore +
        "&maps=true&mapsaccount=mapaspardos@gmail.com";

      if (ubigeoOfStore) {
        let self = this;

        axios
          .get(url)
          .then(function (response) {
            console.log("Se geocodifico correctamente");
            console.log(response);

            self.recibiresultados(response.data);
            //resolve(response.data);
          })
          .catch(function (error) {
            console.log(error);
            //reject(error);
          });
      } else {
        this.$notify({
          title: "Aviso",
          message: "Ingrese una direccion porfavor",
          type: "warning",
        });
      }
    },

    recibiresultados: function (result) {
      console.log("analizar resultado");
      let self = this;
      if (result.status == "OK") {
        console.log("resultado ok");
        var customIcon = new L.Icon({
          iconUrl: require("../../assets/images/icon_marker.png"),
          iconAnchor: [12, 30],
        });

        let results = result.results;

        for (var item in results) {
          if (item == 0) {
            console.log("calcular delivery");

            let coordinates = results[item].geometry.coordinates;
            let latitud = coordinates.lat;
            let longitud = coordinates.lon;

            let tokenObject = JSON.parse(localStorage.getItem("geodir_Token"));
            let token = tokenObject.data.access_token;

            //let token = "7c54939f-6876-4f58-8c0c-a2b19c7906d6";

            axios
              .get(
                this.urlBaseDelivery +
                  "/delivery/calculateNearestRestaurant?latitud=" +
                  latitud +
                  "&longitud=" +
                  longitud +
                  "&idLayerPoligon=1244&idlayerPoint=1243",
                {
                  headers: { Authorization: `Bearer ${token}` },
                }
              )
              .then((response) => {
                self.delivery = response.data;
                //that.delivery.distancia.toFixed(2);
                self.delivery.distancia = (
                  self.delivery.distancia / 1000
                ).toFixed(2);
              });

            var latlng = L.GeoJSON.coordsToLatLng([
              coordinates.lon,
              coordinates.lat,
            ]);

            this.evaluatePrecision(
              results[item].geometry.geocoding_type,
              results[item].result_types
            );

            this.map.setView(latlng, 18, {
              duration: 1,
            });
            var marker = L.marker(latlng, { icon: customIcon })
              .addTo(this.map)
              .bindPopup(results[item].standard_address)
              .openPopup();

            this.$store.commit("SET_LAYER_MARKER", marker);

            break;
          }
        }
      }
    },

    evaluatePrecision: function (nivel_precision_geocoder, nivel_detail) {
      console.log("evaluar precision");
      console.log(nivel_precision_geocoder);

      switch (nivel_precision_geocoder) {
        case "DOOR":
        case "INTERPOLATED":
          this.classForPrecision = "precision-alta";
          this.nivel_search = "Precisión Alta";
          break;
        case "CENTER":
          if (
            nivel_detail.includes("route") ||
            nivel_detail.includes("sublocality")
          ) {
            this.classForPrecision = "precision-media";
            this.nivel_search = "Precisión Media";
          }
          this.classForPrecision = "precision-baja";
          this.nivel_search = "Precisión Baja";
          break;
        default:
          this.classForPrecision = "precision-baja";
          this.nivel_search = "Precisión Baja";
      }
    },
  },
};
</script>
<style>
.box-card {
  margin-top: 20px;
}

.box-card .el-card__header {
  background-color: #ff4240;
  color: white;
  padding: 8px 20px;
}

.box-card .el-card__body {
  position: relative;
  padding: 0px !important;
}

.box-card .el-card__body .text {
  font-weight: bold;
  padding: 20px;
}

.box-card .el-card__body:before {
  background-image: url("~@/assets/images/pardos-logo-negro.png");
  background-repeat: no-repeat;
  background-size: cover;
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  opacity: 0.15;
}

.precision-alta {
  padding: 5px 5px 5px 0px;
  color: #009700;
  font-size: 13px;
  text-align: center;
  border-bottom: #009700 1px solid;
}
.precision-media {
  padding: 5px 5px 5px 0px;
  color: #e69500;
  font-size: 13px;
  text-align: center;
  border-bottom: #e69500 1px solid;
}
.precision-baja {
  padding: 5px 5px 5px 0px;
  color: #0080ff;
  font-size: 13px;
  text-align: center;
  border-bottom: #0080ff 1px solid;
}

.rowComponentOfDirection {
  margin-top: 12px;
}

.rowNumberDirection {
  margin-top: 12px;
}

.containerSearchDirection {
  margin: 10px 10px;
}
.divIconDeleteInputNumberDirection {
  padding: 8px 6px;
}

.containerSearchDirection h5 {
  text-align: center;
}

.inputNumberDirection {
  width: 100% !important;
}

.inputNumberDirection input[type="text"] {
  text-align: left !important;
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
}

.lblNumeroVia {
  font-size: 14px;
}

.inputManzana {
  width: 100% !important;
  font-size: 14px;
}

.rowbtnSearchDirection {
  /*margin: 15px 0px;*/
}

.btnSearchDirection {
  width: 100%;
  border-radius: 2px !important;
}

.inputNumberDirection {
  width: 100%;
  color: #5c5c5c;
  font-size: 14px;
}

.inputNumberDirection.vs-input-number {
  background: white !important;
}

.inputNumberDirection .vs-input-number--input {
  min-width: 100px !important;
  background: white !important;
}

.inner-addon {
  position: relative;
}

/* style icon */
.inner-addon .glyphicon {
  position: absolute;
  padding: 6px;
}

/* align icon */
.left-addon .glyphicon {
  left: 0px;
}
.right-addon .glyphicon {
  right: 0px;
}

/* add padding  */
.left-addon input {
  padding-left: 30px;
}
.right-addon input {
  padding-right: 30px;
}

.iconInput {
  z-index: 2;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.delivery_code .el-input__inner {
  width: 100%;
  height: 25px;
  font-weight: bold;
  color: #ff4240;
  font-size: 12px;
  padding: 0 3px;
}

.notaDelivery {
  font-size: 12px;
  color: #269b26;
  font-style: italic;
}

.value-delivery {
  font-weight: 400;
}
</style>
